import { errorList, errorTranslation } from './urlErrorInfo';

export default function getErrorParams(): ErrorParamsType {
  const urlParams = new URLSearchParams(window.location.search);
  const errorType = urlParams.get('error_type');

  if (errorType) {
    return getParams(urlParams, errorType);
  }
}

function buildErrorInfo(errorType: string): string {
  if (errorList[errorType]?.isAJwebAuthPluginError) {
    return `JWeb Auth Plugin Error: ${errorType}`;
  }
  return `Error Type: ${errorType}`;
}

function getParams(urlParams: URLSearchParams, errorType: string) {
  const status =
    urlParams.get('status') ||
    errorList[errorType]?.errorStatus?.toString() ||
    '520';
  const errorParams: ErrorParamsType = {
    errorMessage: buildErrorInfo(errorType),
    errorDescription: getErrorDescription(
      urlParams.get('error_description'),
      errorType
    ),
    status: getErrorStatus(parseInt(status))
  };

  return errorParams;
}

export function getErrorDescription(
  errorMessage: any,
  errorType: string
): string {
  if (errorMessage) {
    return capitalizeFirstLetter(errorMessage);
  }

  return capitalizeFirstLetter(
    errorList[errorType]?.errorDescription || errorType
  );
}

function getErrorStatus(status: number): string {
  if (errorTranslation[status]) {
    return `${status} - ${errorTranslation[status]}`;
  }

  // Default to a generic error status if not found
  return '520 - Unknown Error';
}

function humanizeString(errorMessage: string): string {
  return errorMessage
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .toLowerCase();
}

function capitalizeFirstLetter(str: string): string {
  const newStr = humanizeString(str);
  return newStr.charAt(0).toUpperCase() + newStr.slice(1);
}

type ErrorParamsType = {
  errorMessage: string;
  errorDescription: string;
  status: string;
};
